var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStage1SelectTitle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 928.1 161.8",
    style: {
      enableBackground: "new 0 0 928.1 161.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#XMLID_00000183944034288144945590000000414090338043519879_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000139287006270236824300000004141072696917181076_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.9775,
    y1: 345.9532,
    x2: 613.488,
    y2: -164.1541
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AC7BB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09822953,
    style: {
      stopColor: "#A477AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6987,
    style: {
      stopColor: "#7660A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6457A0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000065784782298060322360000004756797010209808023_",
    style: {
      fill: "url(#XMLID_00000139287006270236824300000004141072696917181076_)"
    },
    d: " M38.6,0.5h849.9c21.2,0,38.6,17.4,38.6,38.6l0,123.1H1.2c-0.6,0-1.1-0.5-1.1-1.1l0-122C0,17.9,17.4,0.5,38.6,0.5z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage1SelectTitle);
export default __webpack_public_path__ + "static/media/Stage1_SelectTitle.0c8daac4868ef29fa546ea7dade4249f.svg";
export { ForwardRef as ReactComponent };